import Destination from "../components/Destination";
import Trip from "../components/Trip";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Image from "../assets/home.jpg";
function Home(props) {
    return <>
    <Navbar />
    
    <Hero 
    cName="hero"
    heroImg={Image}
    title="Your Journey Your Story"
    text="Share your stories"
    buttonText="Travel Plan"
    url="/"
    btnClass="show"
    />
    <h1>Welcome</h1>

    <Destination/>
    <Trip/>
    <Footer/>
    </>;
  }
  
  export default Home;
  